import { MarketHeader, MarketQrcode } from '@market/react';
import BaseModal from 'components/modals/BaseModal';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { buyerportalCdpClient } from 'services/tracking/cdp/clients/buyerportal';
import { viewQrCodeModalProperties } from 'services/tracking/cdp/events/referrals';

interface QrCodeModalProps {
  onClose: () => void;
  inviteLink: string;
}

export default function QrCodeModal({ onClose, inviteLink }: QrCodeModalProps) {
  const { t } = useTranslation();

  useEffect(() => {
    buyerportalCdpClient.track(
      'View QR Code Modal',
      viewQrCodeModalProperties()
    );
  }, []);

  return (
    <BaseModal
      titleElementId="qr-code-modal"
      onClose={onClose}
      className="top-0 bg-[#1C1C1C]"
    >
      <MarketHeader>
        <h2 id="qr-code-modal-title" className="text-[#FFFFFF]">
          {t('refer.qrCode.title')}
        </h2>
      </MarketHeader>
      <div className="flex justify-center py-11 mt-6 h-[330px]">
        <MarketQrcode content={inviteLink} border={true} />
      </div>
    </BaseModal>
  );
}
